<template>
    <div class="w-768">

        <multi-lang-toggle :form="form"></multi-lang-toggle>

        <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs" class="w-full">
            <div v-for="lang in languages" :key="lang">
                <simple-input
                    v-show="lang === selectedLanguage"
                    v-model="form.title[lang]"
                    emojis
                    class="mb-16"
                >
                    {{ $t('form.title') }} ({{ lang}})
                </simple-input>

              <wysiwyg
                    v-show="lang === selectedLanguage"
                    v-model="form.description[lang]"
                    full-featured
              >
                {{ $t('form.description') }}
                <span v-if="languages.length > 1">({{ lang }})</span>
              </wysiwyg>
            </div>
        </translatable>

        <hr class="my-32 border-primary-20">

        <div class="mb-16">
            <h3 class="mb-16 text-body font-semibold flex items-center">
                {{ $t('jobs.configure_settings.title') }}
            </h3>
            <div>
                <checkbox :checked="form.pagination !== null" @change="form.pagination = $event ? 8 : null" class="mb-16">
                    {{ $t('jobs.configure_settings.pagination_checkbox') }}
                </checkbox>
                <simple-input type="number" v-if="form.pagination !== null" v-model="form.pagination">
                    {{ $t('jobs.configure_settings.pagination_amount') }}
                </simple-input>
            </div>
        </div>

        <div class="pt-24 px-24 bg-primary-5 border border-primary-20 rounded mt-32">
            <label class="mb-16 text-body font-semibold flex items-center">
                <span class="first-letter:uppercase">
                    {{ $t('jobs.filters.title') }}
                </span>
            </label>
            <div class="flex space-x-32 items-stretch">
                <button
                    v-for="filter in filters"
                    :key="'filter-' + filter.title"
                    class="w-128 cursor-pointer mb-16 flex flex-col"
                    @click="updateFilter(filter)"
                >
                    <div
                        class="rounded p-8 w-full relative trans-ease group shadow-md trans-ease flex-grow"
                        :class="[ form.filters[filter.id] ? 'bg-secondary' : 'bg-white' ]"
                    >
                        <div class="w-full h-full relative mb-32">
                            <svg-icon
                                :type="filter.icon"
                                class="max-w-24 max-h-24 trans-ease"
                                :class="[ form.filters[filter.id] ? 'text-white' : 'text-primary-40' ]"
                            ></svg-icon>
                            <div class="leading-snug first-letter:uppercase text-left my-8"
                                 :class="[ form.filters[filter.id] ? 'text-white' : 'text-primary-80' ]">
                                {{ filter.title }}
                            </div>
                        </div>
                        <div
                            class="absolute flex justify-center trans-ease" style="right: 5px; bottom: 5px"
                            :class="[ form.filters[filter.id] ? 'opacity-100' : 'opacity-0' ]"
                        >
                            <svg-icon
                                type="check"
                                class="max-h-32 max-w-32 text-white trans-ease"
                            ></svg-icon>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Translatable from '../forms/Translatable.vue';
import LanguagesMultiToggle from '../forms/LanguagesMultiToggle.vue';
import SvgIcon from '../ui/SvgIcon';
import Checkbox from "../forms/Checkbox";
import SimpleInput from "../forms/Input";
import {mapState} from 'pinia';
import {useMainStore} from '../../state/store';
import wysiwyg from "../forms/Wysiwyg.vue";


export default {
    components: {
      wysiwyg,
        SimpleInput,
        Checkbox,
        'translatable': Translatable,
        'multi-lang-toggle': LanguagesMultiToggle,
        'svg-icon': SvgIcon
    },
    props: {
        form: {
            required: true,
        },
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.title[languages[index]] && this.form.data.published[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
        filters() {
            return [
                {
                    id: 'location',
                    title: this.$t('jobs.filters.location'),
                    icon: "location"
                },
                {
                    id: 'type',
                    title: this.$t('jobs.filters.type'),
                    icon: 'schedule'
                },
                {
                    id: 'tags',
                    title: this.$t('jobs.filters.tags'),
                    icon: "filter-alt"
                },
            ];
        }
    },
    methods: {
        updateFilter(filter) {
            let filters = this.form.filters;
            filters[filter.id] = !filters[filter.id];
            return this.form.filters = filters;
        }
    }
}
</script>
